<template>
  <div>
    <div class="cg-bars">
      <div
        v-for="bar in bars"
        :key="bar.label"
        class="cg-bar"
        role="img"
        :title="bar.title"
        :aria-label="bar.title"
      >
        <div
          class="d-flex flex-column justify-content-end overflow-hidden"
          :style="{ height: bar.pct, background: FILL[bar.fill] }"
        >
          <!-- Partly delivered month: the delivered share sits at the bottom in the received colour. -->
          <div
            v-if="bar.deliveredPct"
            :style="{ height: bar.deliveredPct, background: FILL.actualFeed }"
          />
        </div>
      </div>
    </div>
    <div class="cg-strip cg-axis">
      <span
        v-for="bar in bars"
        :key="bar.label"
        class="cg-strip-cell cg-micro text-center"
        >{{ bar.label }}</span
      >
    </div>
    <LegendSwatches :legend />
  </div>
</template>

<script setup lang="ts">
import type { LegendItem, MonthBar } from "@/compliance_groups/fixture/derive";
import { FILL } from "@/compliance_groups/fixture/fills";
import LegendSwatches from "./LegendSwatches.vue";

defineProps<{ bars: MonthBar[]; legend: LegendItem[] }>();
</script>
